var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.eligibilityInputs, function (eligibility, index) {
      return _c("div", { key: index }, [
        _c("div", { staticClass: "card-item shadowless" }, [
          eligibility.inputOrigin === "EXTERNAL_PROVIDER"
            ? _c("div", { staticClass: "container-automatic" }, [
                _c(
                  "div",
                  { staticClass: "container-automatic-input" },
                  [
                    _c("span", { staticClass: "label-text" }, [
                      _c("b", [
                        _vm._v(" " + _vm._s(_vm.automaticTitles[index]) + ": "),
                      ]),
                    ]),
                    _c("BaseInput", {
                      staticClass: "eligibility-input-automatic",
                      attrs: {
                        id: `eligibility-automatic-input-${index}`,
                        disabled: "",
                        value: eligibility.value,
                        type: "text",
                      },
                    }),
                    _c(
                      "small",
                      {
                        staticClass: "external-provider-equifax",
                        attrs: { id: `external-provider-${index}` },
                      },
                      [_vm._v("Equifax")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "container-forced-switch" },
                  [
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: eligibility.forcedValue,
                            expression: "eligibility.forcedValue",
                          },
                        ],
                        staticClass: "check-passed",
                      },
                      [_vm._v("Aprobado")]
                    ),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !eligibility.forcedValue,
                            expression: "!eligibility.forcedValue",
                          },
                        ],
                        staticClass: "check-forced",
                      },
                      [_vm._v("Forzar aprobación")]
                    ),
                    _c("b-switch", {
                      class: `check-${eligibility.forcedValue}`,
                      attrs: {
                        id: `0-eligibility-criteria-${index}`,
                        disabled: false,
                        "native-value": false,
                        "true-value": true,
                        "false-value": false,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateSwitchs($event, index)
                        },
                      },
                      model: {
                        value: eligibility.forcedValue,
                        callback: function ($$v) {
                          _vm.$set(eligibility, "forcedValue", $$v)
                        },
                        expression: "eligibility.forcedValue",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          eligibility.inputOrigin === "USER_SWITCH"
            ? _c(
                "div",
                { staticClass: "container-switch" },
                [
                  _c("span", [
                    _c("b", [_vm._v(" " + _vm._s(_vm.titles[index]) + " ")]),
                  ]),
                  _c("b-switch", {
                    class: `check-${eligibility.forcedValue}`,
                    attrs: {
                      id: `0-eligibility-criteria-${index}`,
                      disabled: false,
                      "native-value": false,
                      "true-value": true,
                      "false-value": false,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateSwitchs($event, index)
                      },
                    },
                    model: {
                      value: eligibility.forcedValue,
                      callback: function ($$v) {
                        _vm.$set(eligibility, "forcedValue", $$v)
                      },
                      expression: "eligibility.forcedValue",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          eligibility.forcedValue
            ? _c(
                "div",
                { staticClass: "is-flex is-align-items-center mt-2" },
                [
                  _vm._m(0, true),
                  _c("BaseInput", {
                    staticClass: "eligibility-input",
                    attrs: {
                      id: `eligibility-comment-input-${index}`,
                      value: eligibility.comment,
                      type: "text",
                    },
                    on: {
                      input: (newValue) => _vm.addComment(newValue, index),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label-text-coment" }, [
      _c("b", [_vm._v("Comentario:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }